module.exports = __webpack_public_path__ + "static/media/empty-images.8c0d7b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty-images.svg
// module id = 135
// module chunks = 33